
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-scenarios/[slug]/latest-run",
      function () {
        return require("private-next-pages/test-scenarios/[slug]/latest-run.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test-scenarios/[slug]/latest-run"])
      });
    }
  